import React from 'react';
import Charts from '@pages-clean/dummy-page/pages/charts';

const ChartsPage = () => {
    return <Charts />;
};

export default ChartsPage;
